<template>
  <div>
    <main class="profile">
      <profile-section></profile-section>
      <section id="tabs">
        <div class="container">
          <div class="card" style="box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 40px -6px;">
            <select id="selectTabs" v-model="currentTab" class="nav-select-profile form-control">
              <option value="profile">{{$t('Dettagli personali')}}</option>
              <option value="contacts">{{$t('Contatti')}}</option>
              <option value="socials">{{$t('Social network connessi')}}</option>
              <option value="privacy">{{$t('Privacy')}}</option>
              <option value="settings">{{$t('Impostazioni')}}</option>
            </select>
            <ul class="nav nav-edit-profile" id="ulTabs" role="profileTabs">
              <li class="nav-item">
                <a
                  class="nav-link btn-not-spinner"
                  :class="{active: currentTab === 'profile'}"
                  id="profile-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="profilePanel"
                  aria-selected="true"
                  @click="currentTab = 'profile'"
                >{{$t('Dettagli personali')}}</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link btn-not-spinner"
                  :class="{active: currentTab === 'contacts'}"
                  id="contacts-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="contactsPanel"
                  aria-selected="false"
                  @click="currentTab = 'contacts'"
                >{{$t('Contatti')}}</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link btn-not-spinner"
                  :class="{active: currentTab === 'socials'}"
                  id="socials-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="socialsPanel"
                  aria-selected="false"
                  @click="currentTab = 'socials'"
                >{{$t('Social network connessi')}}</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link btn-not-spinner"
                  :class="{active: currentTab === 'privacy'}"
                  id="privacy-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="privacyPanel"
                  aria-selected="false"
                  @click="currentTab = 'privacy'"
                >{{$t('Privacy')}}</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link btn-not-spinner"
                  :class="{active: currentTab === 'settings'}"
                  id="settings-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="settingsPanel"
                  aria-selected="false"
                  @click="currentTab = 'settings'"
                >{{$t('Impostazioni')}}</a>
              </li>
            </ul>
            <div id="profilePanels" class="tab-content">
              <div
                id="profilePanel"
                v-if="currentTab === 'profile'"
                role="tabpanel"
                aria-labelledby="profile-tab"
                class="tab-pane fade active show"
              >
                <div class="row">
                  <template v-for="(attributeValue, attributeKey) in profile">
                    <template
                      v-if="['first_name','last_name','birthday','gender'].indexOf(attributeKey) !== -1"
                    >
                      <div class="col-12 col-md-6" v-bind:key="attributeKey">
                        <div class="form-group" style="position: relative;">
                          <template
                            v-if="$store.state.brand.attributes_and_types[attributeKey].type !== 'select'"
                          >
                            <template v-if="attributeKey === 'gender'">
                              <label
                                :for="attributeKey"
                                class="h5"
                                style="top:-20px"
                              >{{$t($store.state.brand.attributes_and_types[attributeKey].label)}}</label>
                              <select
                                class="form-control withval open"
                                id="gender"
                                style="height:35px;"
                                :name="attributeKey"
                                required
                                v-model="profile[attributeKey]"
                              >
                                <option value="male">{{$t('Maschio')}}</option>
                                <option value="female">{{$t('Femmina')}}</option>
                                <option value="other">{{$t('Altro')}}</option>
                              </select>
                            </template>
                            <template v-else>
                              <template
                                v-if="$store.state.brand.attributes_and_types[attributeKey].type === 'number'"
                              >
                                <input
                                  :name="attributeKey"
                                  type="number"
                                  step=".5"
                                  class="form-control withval open"
                                  :id="attributeKey"
                                  :placeholder="$store.state.brand.attributes_and_types[attributeKey].label"
                                  autocomplete="false"
                                  v-model.trim="profile[attributeKey]"
                                  required
                                >
                              </template>
                              <template
                                v-else-if="$store.state.brand.attributes_and_types[attributeKey].type === 'address'"
                              >
                                <input
                                  :name="attributeKey"
                                  type="text"
                                  class="form-control withval open addressAutocomplete"
                                  :id="attributeKey"
                                  :placeholder="$store.state.brand.attributes_and_types[attributeKey].label"
                                  ref="addressAutocomplete"
                                  v-model.trim="profile[attributeKey]"
                                  required
                                >
                              </template>
                              <template
                                v-else-if="$store.state.brand.attributes_and_types[attributeKey].type === 'city'"
                              >
                                <input
                                  :name="attributeKey"
                                  type="text"
                                  class="form-control withval open cityAutocomplete"
                                  :id="attributeKey"
                                  :placeholder="$store.state.brand.attributes_and_types[attributeKey].label"
                                  ref="cityAutocomplete"
                                  v-model.trim="profile[attributeKey]"
                                  required
                                >
                              </template>
                              <template
                                v-else-if="$store.state.brand.attributes_and_types[attributeKey].type === 'date'"
                              >
                                <template v-if="attributeKey === 'birthday'">
                                  <input
                                    :name="attributeKey"
                                    type="text"
                                    class="form-control withval open form-date"
                                    :id="attributeKey"
                                    :placeholder="$store.state.brand.attributes_and_types[attributeKey].label"
                                    data-date-format="DD/MM/YYYY"
                                    v-model.trim="profile[attributeKey]"
                                    autocomplete="false"
                                    required
                                  >
                                </template>
                                <template v-else>
                                  <input
                                    :name="attributeKey"
                                    :type="$store.state.brand.attributes_and_types[attributeKey].type"
                                    class="form-control withval open"
                                    :id="attributeKey"
                                    :placeholder="$store.state.brand.attributes_and_types[attributeKey].label"
                                    data-date-format="DD/MM/YYYY"
                                    autocomplete="false"
                                    required
                                  >
                                </template>
                              </template>
                              <template v-else>
                                <input
                                  :name="attributeKey"
                                  :type="$store.state.brand.attributes_and_types[attributeKey].type"
                                  class="form-control withval open"
                                  :id="attributeKey"
                                  :placeholder="$store.state.brand.attributes_and_types[attributeKey].label"
                                  autocomplete="false"
                                  v-model.trim="profile[attributeKey]"
                                  required
                                >
                              </template>
                              <label
                                :for="attributeKey"
                                class="h5"
                              >{{$t($store.state.brand.attributes_and_types[attributeKey].label)}}</label>
                              <template v-if="attributeKey === 'birthday'">
                                <span
                                  class="invalid-feedback invalid-feedback-date"
                                  style="position: absolute;bottom: 0;left:0"
                                >
                                  <strong v-if="dateError">{{ dateError }}</strong>
                                </span>
                              </template>
                            </template>
                          </template>
                        </div>
                      </div>
                    </template>
                  </template>
                </div>
                <div class="row" style="padding-top:50px;">
                  <template v-for="(attributeValue, attributeKey) in profile">
                    <template
                      v-if="['address','city','emails','mobiles', 'first_name','last_name','birthday','gender'].indexOf(attributeKey) === -1 "
                    >
                      <div class="col-12 col-md-6" v-bind:key="attributeKey">
                        <div class="form-group" style="position:relative">
                          <template
                            v-if="attributeValue != '' && $store.state.brand.attributes_and_types[attributeKey] !== undefined"
                          >
                            <template
                              v-if="$store.state.brand.attributes_and_types[attributeKey].type !== 'select'"
                            >
                              <template
                                v-if="$store.state.brand.attributes_and_types[attributeKey].type === 'number'"
                              >
                                <input
                                  :name="attributeKey"
                                  type="number"
                                  step=".5"
                                  class="form-control"
                                  :id="attributeKey"
                                  placeholder="@lang($attributes[$k]['label'])"
                                  autocomplete="false"
                                  v-model.trim="profile[attributeKey]"
                                  required
                                >
                              </template>
                              <template
                                v-else-if="$store.state.brand.attributes_and_types[attributeKey].type === 'address'"
                              >
                                <input
                                  :name="attributeKey"
                                  type="text"
                                  class="form-control addressAutocomplete"
                                  :id="attributeKey"
                                  placeholder="@lang($attributes[$k]['label'])"
                                  v-gaddress
                                  v-model="profile[attributeKey]"
                                  autocomplete="false"
                                  required
                                >
                              </template>
                              <template
                                v-else-if="$store.state.brand.attributes_and_types[attributeKey].type === 'city'"
                              >
                                <input
                                  :name="attributeKey"
                                  type="text"
                                  class="form-control cityAutocomplete"
                                  :id="attributeKey"
                                  :placeholder="$t($store.state.brand.attributes_and_types[attributeKey].label)"
                                  v-gcity
                                  v-model="profile[attributeKey]"
                                  autocomplete="false"
                                  required
                                >
                              </template>
                              <template
                                v-else-if="$store.state.brand.attributes_and_types[attributeKey].type === 'date'"
                              >
                                <input
                                  :name="attributeKey"
                                  :type="$store.state.brand.attributes_and_types[attributeKey]"
                                  class="form-control"
                                  :id="attributeKey"
                                  :placeholder="$t($store.state.brand.attributes_and_types[attributeKey].label)"
                                  data-date-format="DD/MM/YYYY"
                                  autocomplete="false"
                                  required
                                >
                              </template>
                              <template v-else>
                                <input
                                  :name="attributeKey"
                                  :type="$store.state.brand.attributes_and_types[attributeKey]"
                                  class="form-control"
                                  :id="attributeKey"
                                  :placeholder="$t($store.state.brand.attributes_and_types[attributeKey].label)"
                                  v-model.trim="profile[attributeKey]"
                                  autocomplete="false"
                                  required
                                >
                              </template>
                              <label
                                :id="attributeKey"
                                class="h5"
                              >{{$t($store.state.brand.attributes_and_types[attributeKey].label)}}</label>
                            </template>
                            <template v-else>
                              <label
                                :id="attributeKey"
                                class="h5"
                                style="top:-20px"
                              >{{$t($store.state.brand.attributes_and_types[attributeKey].label)}}</label>
                              <select
                                class="form-control"
                                :id="attributeKey"
                                style="height:35px;"
                                :name="attributeKey"
                                v-model.trim="profile[attributeKey]"
                                required
                              >
                                {{attributeValue}}
                                <option
                                  v-for="(optionKey, optionValue) in $store.state.brand.attributes_and_types[attributeKey].options"
                                  :value="optionValue"
                                  v-bind:key="optionKey"
                                >{{optionKey}}</option>
                              </select>
                            </template>
                          </template>
                        </div>
                      </div>
                    </template>
                  </template>
                </div>
                <div class="row" style="padding-top: 50px;">
                  <div class="col-6 text-left">
                    <p
                      class="logout-text"
                      @click="$store.dispatch('logout'); $router.push('/')"
                    >Logout</p>
                  </div>
                  <div class="col-6 text-right">
                    <button
                      type="submit"
                      class="btn btn-primary"
                      @click="updateProfilingAttributes"
                      :disabled="dateError"
                    >{{$t('Aggiorna')}}</button>
                  </div>
                </div>
              </div>
              <div
                id="contactsPanel"
                v-if="currentTab === 'contacts'"
                role="tabpanel"
                aria-labelledby="contacts-tab"
                class="tab-pane fade active show"
              >
                <input type="hidden" name="section" value="profile" class="withval">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="form-group" style="position: relative; height: auto;">
                      <label class="h5" style="position: relative;">{{$t('Email')}}</label>
                      <div
                        class="item row"
                        v-for="(email, emailKey) in profile.emails"
                        v-bind:key="emailKey"
                      >
                        <div class="col-10">{{email.email}}</div>
                        <div class="col-1 text-center">
                          <button class="btn p-0 btn-link text-muted" @click="editContact(email)">
                            <i class="fas fa-pencil-alt"></i>
                          </button>
                        </div>
                        <div class="col-1 text-right">
                          <button
                            class="btn p-0 btn-link"
                            :class="{'text-primary' : email.primary, 'text-muted': !email.primary}"
                            @click="setPrimaryEmail(email)"
                          >
                            <i class="fas fa-bell"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group" style="position: relative; height: auto;">
                      <label class="h5" style="position: relative;">{{$t('Cellulare')}}</label>
                      <div
                        class="item row"
                        v-for="(mobile, mobileKey) in profile.mobiles"
                        v-bind:key="mobileKey"
                      >
                        <div class="col-10">{{mobile.number}}</div>
                        <div class="col-1 text-center">
                          <button @click="editContact(mobile)" class="btn p-0 btn-link text-muted">
                            <i class="fas fa-pencil-alt"></i>
                          </button>
                        </div>
                        <div class="col-1 text-right">
                          <button
                            class="btn p-0 btn-link"
                            :class="{'text-primary': mobile.primary, 'text-muted': !mobile.primary}"
                            @click="setPrimaryMobile(mobile)"
                          >
                            <i class="fas fa-bell"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="socialsPanel"
                v-if="currentTab === 'socials'"
                role="tabpanel"
                aria-labelledby="socials-tab"
                class="tab-pane fade active show"
              >
                <div
                  class="row mb-2"
                  v-for="(profiles, provider) in profileShow"
                  v-bind:key="provider"
                >
                  <div
                    class="col-12 col-md-4 mt-2 mb-2"
                    v-for="(profile, profileKey) in profiles"
                    v-bind:key="profileKey"
                  >
                    <div
                      class="profile-social icon-left"
                      style="width: 100%"
                      :class="'social-'+profile.presenter.class"
                    >
                      <div class="presenter-icon">
                        <template v-if="profile.provider === 'garmin-connect'">
                          <div v-html="garminLogo" class="garmin-connect-logo"></div> 
                        </template>
                        <template v-else-if="profile.presenter.icon.type === 'icon'">
                          <i :class="profile.presenter.icon.class"></i>
                        </template>
                        <template v-else-if="profile.presenter.icon.type === 'image'">
                          <img
                            :class="profile.presenter.icon.class"
                            :src="profile.presenter.icon.src"
                            :alt="profile.presenter.label"
                          >
                        </template>
                      </div>
                      <template v-if="profile.provider === 'apple'">
                          Apple Sign In
                      </template>
                      <template v-else-if="profile.provider === 'garmin-connect'">
                          Garmin Connect
                      </template>
                      <div class="to-show">{{profile.presenter.to_show}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="privacyPanel"
                v-if="currentTab === 'privacy'"
                role="tabpanel"
                aria-labelledby="privacy-tab"
                class="tab-pane fade active show"
              >
                <div
                  class="row"
                  v-for="(value, attributeName) in privacyLabels"
                  v-bind:key="attributeName"
                >
                  <div class="form-check c-registration-check">
                    <input
                      type="checkbox"
                      :name="attributeName"
                      :id="attributeName"
                      v-model="privacyAttributes[attributeName]"
                      class="form-check-input"
                    >
                    <label
                      :for="attributeName"
                      class="form-check-label"
                      style="color: rgb(66, 80, 113);"
                    >{{value}}</label>
                  </div>
                </div>
                <div class="row" style="padding-top: 50px;">
                  <div class="col-12 text-right">
                    <button
                      type="submit"
                      @click="updateAgreements"
                      class="btn btn-primary"
                    >{{$t('Aggiorna')}}</button>
                  </div>
                </div>
              </div>
              <div
                id="settingsPanel"
                v-if="currentTab === 'settings'"
                role="tabpanel"
                aria-labelledby="settings-tab"
                class="tab-pane fade active show"
              >
                <p>{{$t('For any problems or warnings write us')}}</p>
                <a :href="'mailto:'+$store.state.brand.email">
                  <button type="button" class="btn btn-primary">
                    <i class="far fa-life-ring"></i> Support
                  </button>
                </a>
                <hr>
                <template v-if="$store.getters.getUserRemoveRequestedAt === null">
                  <p>
                    {{$t('Do you want to delete your account?')}}
                    <br>
                    <b>{{$t('This action is irreversible')}}</b>
                  </p>
                  <button
                    type="button"
                    data-toggle="modal"
                    data-target="#exampleModal"
                    class="btn btn-link text-danger"
                    @click="showDeleteModal = true"
                  >{{$t('Delete account')}}</button>
                </template>
                <template v-else>
                  <p>
                    {{$t('Do you want to restore your account?')}}
                    <br>
                  </p>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="undoRemoval"
                  >{{$t('Reactivate')}}</button>
                </template>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <transition name="modal" v-if="showDeleteModal">
      <div class="modal" style="display:block;background-color:rgba(0,0,0,.5)">
        <div
          class="modal fade show"
          style="display: block"
          id="exampleModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header" style="border-bottom:none">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true" @click="showDeleteModal = false">&times;</span>
                </button>
              </div>
              <div class="modal-body text-center">
                <h3>{{$t('Are you sure you want to delete your account?')}}</h3>
                <h4>{{$t('This action is irreversible')}}</h4>
              </div>
              <div class="modal-footer text-center" style="border-top:none">
                <button @click="deleteAccount" class="btn btn-danger btn-block">{{$t('Delete')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ProfileSection from "./Campaign/ProfileSection";
import _ from "lodash";
import moment from "moment";
import iconGarmin from'./../assets/svg/garmin_connect_logo.svg';
export default {
  name: "profile",
  props: {
    preselectedTab: {
      default: null
    }
  },
  data() {
    return {
      profile: undefined,
      profileShow: undefined,
      currentTab: "profile",
      privacyLabels: {
        marketing: this.$i18n.t("Agree with marketing terms"),
        profilation: this.$i18n.t("Agree with profilation terms"),
        third: this.$i18n.t("Agree with third party marketing terms"),
        third_profilation: this.$i18n.t(
          "Agree with third party profilation terms"
        )
      },
      privacyAttributes: {
        marketing: this.$store.state.user.marketing,
        profilation: this.$store.state.user.profilation,
        third: this.$store.state.user.third,
        third_profilation: this.$store.state.user.third_profilation
      },
      showDeleteModal: false,
      garminLogo: iconGarmin
    };
  },
  components: {
    ProfileSection
  },
  mounted() {
    if(this.preselectedTab) {
      this.currentTab = this.preselectedTab
    }
  },
  created() {
    this.getProfile();
  },
  computed: {
    dateError() {
      if (this.profile == undefined || this.profile.birthday == undefined) {
        return null;
      }

      if (!moment(this.profile.birthday, 'dd/mm/YYYY').isValid()) {
        return "La data deve essere valida ed in formato dd/mm/YYYY";
      }

      if (moment().diff(this.profile.birthday, "years") < 16) {
        return "Devi avere 16 anni per poter partecipare";
      }

      return null;
    }
  },
  methods: {
    async getProfile() {
      this.$store.commit("showSpinner");
      let response = await this.$http.get(
        "/api/v1/campaigns/" + this.$store.state.campaign.id + "/users/profile"
      );
      this.profile = _.get(response, "data.data.profile");
      this.profileShow = _.get(response, "data.data.profile_show");
      this.$store.commit("hideSpinner");
    },
    async updateProfilingAttributes() {
      if (this.dateError) {
        return;
      }
      this.$store.commit("showSpinner");
      try {
        let response = await this.$http.post(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/profile/attributes",
          {
            profiling_attributes: _.omit(this.profile, ["mobiles", "emails"])
          }
        );
      } catch (e) {
        this.$store.commit("pushMessage", {
          type: "error",
          title: "Error",
          text: "An error occurred"
        });
      }

      this.$store.commit("hideSpinner");
    },
    async updateAgreements() {
      this.$store.commit("showSpinner");
      try {
        await this.$http.post(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/agreements",
          {
            agreements: this.privacyAttributes
          }
        );

        await this.$store.dispatch("getUserTasks");
      } catch (e) {
        this.$store.commit("pushMessage", {
          type: "waiting",
          title: "Something went wrong",
          text: "Please retry"
        });
      }
      this.$store.commit("hideSpinner");
    },
    async deleteAccount() {
      this.$store.commit("showSpinner");

      try {
        await this.$http.delete(
          "/api/v1/campaigns/" + this.$store.state.campaign.id + "/users"
        );
        this.$store.dispatch("getUserInfo");
        await this.$store.dispatch("getUnreadMessages");
      } catch (e) {
        this.$store.commit("pushMessage", {
          type: "error",
          title: "Error",
          text: "An error occurred"
        });
      }
      this.showDeleteModal = false;
      this.$store.commit("hideSpinner");
    },
    async undoRemoval() {
      this.$store.commit("showSpinner");
      try {
        await this.$http.get(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/undelete"
        );

        this.$store.commit("updateUserRemoveRequestedAt", null);
        await this.$store.dispatch("getUnreadMessages");
      } catch (e) {
        this.$store.commit("pushMessage", {
          type: "error",
          title: "Error",
          text: "An error occurred"
        });
      }

      this.$store.commit("hideSpinner");
    },
    async setPrimaryEmail(email) {
      if (email.primary) {
        return;
      }
      this.$store.commit("showSpinner");
      try {
        await this.$http.post(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/emails/" +
            email.id +
            "/setPrimary"
        );

        this.getProfile();
      } catch (e) {
        this.$store.commit("pushMessage", {
          type: "error",
          title: "Error",
          text: "An error occurred"
        });
      }

      this.$store.commit("hideSpinner");
    },
    async setPrimaryMobile(mobile) {
      if (mobile.primary) {
        return;
      }
      this.$store.commit("showSpinner");
      try {
        await this.$http.post(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/mobiles/" +
            mobile.id +
            "/setPrimary"
        );

        this.getProfile();
      } catch (e) {
        this.$store.commit("pushMessage", {
          type: "error",
          title: "Error",
          text: "An error occurred"
        });
      }

      this.$store.commit("hideSpinner");
    },
    async editContact(contact) {
      this.$router.push({ name: "editAddress", params: { address: contact } });
    }
  }
};
</script>
<style>
#tabs {
  margin-top: 50px;
}
.nav-select-profile {
  margin: 10px;
  width: auto;
  display: none;
}
#tabs {
  margin-top: 50px;
}

#tabs .card {
  border: none;
}

.c-points__icon {
  margin-right: 0.5rem;
}
hr {
  display: block;
  border-top: 1px solid #dde3eb;
}
.c-registration-check {
  margin: 0.75rem 0;
}

.item {
  padding: 0.75rem 0;
  margin-bottom: -1px;
  border-bottom: 1px solid #dde3eb;
  color: #42507180;
  font-size: 14px;
}

@media (min-width: 768px) {
  .user-basic .col-12:first-of-type {
    border-right: 1px solid var(--primary);
  }
}

@media (min-width: 769px) {
  #ulTabs {
    display: flex;
  }

  #selectTabs {
    display: none;
  }
}

@media (max-width: 768px) {
  #selectTabs {
    display: block;
  }

  #ulTabs {
    display: none;
  }
}

.user-basic .card-sector {
  width: 50%;
  padding: 0 1rem;
}
.user-basic .card-sector .card-title {
  line-height: 30px;
  margin-bottom: 0;
}
.user-basic .card-sector .card-title div {
  display: block;
  float: left;
}
.user-basic .card-sector .card-title svg {
  height: 30px;
  fill: currentColor;
}
.profile-social {
  position: relative;
}
.profile-social > div {
  display: inline-block;
}
.profile-social.social-twitter {
  color: #2aa3f0;
}
.profile-social.social-facebook {
  color: #395794;
}
.profile-social.social-instagram {
  color: #dd2a7b;
}
.profile-social.social-linkedin {
  color: #0077b7;
}
.profile-social > div.presenter-icon {
  width: 39px;
  overflow: hidden;
}
.profile-social > div.to-show {
  width: calc(100% - 43px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 28px;
  line-height: 28px;
}
select.form-control {
  background-image: url("/images/tenants/fir/triangle_dropdown.svg") !important;
  background-size: auto 30%;
  background-repeat: no-repeat;
  background-position: 98% 50%;
}
@media (max-width: 768px) {
  .nav-select-profile {
    display: block;
    position: relative;
    background-image: url("/images/tenants/fir/triangle_dropdown.svg");
    background-size: auto 30%;
    background-repeat: no-repeat;
    background-position: 98% 50%;
  }
  .nav-select-profile:focus,
  .nav-select-profile:active {
    background-image: url("/images/tenants/fir/triangle_dropdown_focus.svg");
    background-size: auto 30%;
    background-repeat: no-repeat;
    background-position: 98% 50%;
  }
  section#tabs .tab-content .tab-pane {
    padding: 20px;
    padding-top: 30px;
  }
  .nav-edit-profile {
    display: none;
  }
  .user-basic .card-sector .card-title {
    font-size: 16px;
  }
  .c-points-recap {
    margin-top: 1.5rem;
  }
  .c-points-recap__box {
    text-align: center;
  }
  .user-basic .card-sector .card-title {
    display: flex;
    justify-content: center;
  }
  .user-basic .card-sector .metric {
    padding-left: 0;
  }
  .c-points__icon {
    margin-right: 0.5rem;
  }
}
.form-group > div.hint {
  position: absolute;
  display: none;
  width: 100%;
  padding: 0.375rem 0;
  font-size: 14px;
  line-height: 1.6;
  color: #a8a8a9;
  font-weight: bold;
  background-color: transparent;
  background-image: none;
  background-clip: padding-box;
  border: none;
  top: 0;
  left: 0;
  -webkit-transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  z-index: 1;
}
a {
  cursor: pointer;
}

.logout-text{
  color: red;
  cursor: pointer;
  font-size: 22px;
  font-weight: normal;
}
</style>

